import { useTranslation } from 'react-i18next';
import {
  ErrorPage,
  LoadingElement,
  PageContainer,
  PageHeader,
} from '../../../shared_components';
import { useEffect, useState } from 'react';
import { Button, Space, Stack, Text } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { useKeycloakStore, useUserDataStore } from '../../../shared_stores';
import { intervalTimeInMs } from '../../payment';

export const ReportsLandingPage = () => {
  const { t } = useTranslation(['common', 'reports']);
  const navigate = useNavigate();
  const kcStore = useKeycloakStore();
  const userDataStore = useUserDataStore();
  const [reportAvailable, setReportAvailable] = useState(false);
  const params = new URLSearchParams(window.location.search);

  const paymentToken = params.get('token');

  useEffect(() => {
    const interval = setInterval(() => {
      if (paymentToken) {
        void userDataStore.checkOrderStatus(paymentToken);
      }
    }, intervalTimeInMs);
    return () => clearInterval(interval);
  });

  useEffect(() => {
    if (userDataStore.reportDone) {
      setReportAvailable(true);
    }
  }, [userDataStore.reportDone]);

  if (!paymentToken) {
    return <ErrorPage />;
  }

  return (
    <PageContainer>
      <Stack style={{ height: '100%' }}>
        <PageHeader
          title={
            reportAvailable
              ? t('reports:report_landing_title_done')
              : t('reports:report_landing_title_waiting')
          }
          lowMargin
        />
        <LoadingElement
          padding="var(--mantine-spacing-lg)"
          done={reportAvailable}
          scale={1.9}
        />
        <Space h={'var(--mantine-spacing-xs)'} />

        <Stack style={{ flexGrow: 1 }}>
          <Stack style={{ flexGrow: 1 }}>
            {reportAvailable ? (
              <>
                <Text>{t('reports:report_landing_page_message')}</Text>
                {kcStore.authenticated ? (
                  <Text>{t('reports:report_landing_page_redirect')}</Text>
                ) : (
                  <Text>{t('reports:report_landing_page_question')}</Text>
                )}
              </>
            ) : (
              <Text>{t('reports:report_landing_page_waiting_message')}</Text>
            )}
            <Space />
          </Stack>
          {!kcStore.authenticated && (
            <>
              <Button
                onClick={() => {
                  void navigate(`/login?redirectUri=${window.location}`);
                }}
              >
                {t('login')}
              </Button>
              {/* TODO CBYN-103 redirect here after registration is complete */}
              <Button
                variant="light"
                onClick={() => {
                  void navigate('/register');
                }}
              >
                {t('common:register')}
              </Button>
              {/* TODO CBYN-136 link to report once available */}
              {reportAvailable ? (
                <Button
                  variant="text"
                  onClick={() => {
                    void navigate(`/reports/overview?token=${paymentToken}`);
                  }}
                >
                  {t('reports:continue_without_account')}
                </Button>
              ) : (
                <Space h={60} />
              )}
            </>
          )}
        </Stack>
      </Stack>
    </PageContainer>
  );
};
